export const API_URL =
  window.location.protocol + "//" + window.location.hostname;
